import type { AmlHistoryItemData } from "@/store";
import { BalanceInfo, GeneralInfo } from "@/components";
import { AmlCheckAssets } from "./AmlCheckAssets";
import { getTokenTitelize } from "@/helpers";

import styles from "./AddressInfo.module.sass";

interface TokenListProps {
  list?: Record<string, any>;
}

const TokenList = ({ list = {} }: TokenListProps) => {
  if (!list && !Object.keys(list)) {
    return null;
  }

  const filledTokenKeys = Object.keys(list).filter(
    (contract: string) => list[contract].length > 0,
  );

  return (
    <>
      {filledTokenKeys.map((contract: string) => (
        <div className={styles.general} key={contract}>
          <AmlCheckAssets
            protocol={getTokenTitelize(contract)}
            assets={list[contract]}
          />
        </div>
      ))}
    </>
  );
};

interface AddressInfoProps {
  item: AmlHistoryItemData;
  isLoading?: boolean;
}

const AddressInfo = ({ item, isLoading }: AddressInfoProps) => {
  const { asset, network, addressDetailsData, addressOwner } = item;

  const hasBalanceInfo = () => {
    return !!(
      item?.addressDetailsData?.balance_usd ||
      item?.addressDetailsData?.balance ||
      item?.addressDetailsData?.balance_approximate
    );
  };

  const hasGeneralInfo = () => {
    return !!(item?.addressOwner || item?.addressDetailsData?.n_txs);
  };

  const hasAdditionalInfo = () => {
    return !!(hasBalanceInfo() || hasGeneralInfo());
  };

  if (!isLoading && !hasAdditionalInfo()) {
    return (
      <div className={styles.box}>
        <div>
          <b>We didn&apos;t find anything</b>
        </div>
        <div>We checked our databases and didn&apos;t find any information</div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className={styles.box}>
        <div className={styles.skeleton}>
          <div className={styles.skeletonTitle} />
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLine} />
        </div>
      </div>
    );
  }

  return (
    <>
      {hasBalanceInfo() && (
        <BalanceInfo data={{ asset, network, addressDetailsData }} />
      )}
      {hasGeneralInfo() && (
        <GeneralInfo
          addressDetailsData={addressDetailsData}
          addressOwner={addressOwner}
        />
      )}
      <TokenList list={item?.addressDetailsData?.tokens} />
    </>
  );
};

export default AddressInfo;
